import { render, staticRenderFns } from "./NsProductPrice.vue?vue&type=template&id=83d50562&"
import script from "./NsProductPrice.vue?vue&type=script&lang=js&"
export * from "./NsProductPrice.vue?vue&type=script&lang=js&"
import style1 from "./NsProductPrice.vue?vue&type=style&index=1&lang=scss&module=%24x&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$x"] = (style1.locals || style1)
        Object.defineProperty(this, "$x", {
          configurable: true,
          get: function () {
            return cssModules["$x"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./NsProductPrice.vue?vue&type=style&index=1&lang=scss&module=%24x&"], function () {
          var oldLocals = cssModules["$x"]
          if (oldLocals) {
            var newLocals = require("./NsProductPrice.vue?vue&type=style&index=1&lang=scss&module=%24x&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$x"] = newLocals
              require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js").rerender("83d50562")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83d50562')) {
      api.createRecord('83d50562', component.options)
    } else {
      api.reload('83d50562', component.options)
    }
    module.hot.accept("./NsProductPrice.vue?vue&type=template&id=83d50562&", function () {
      api.rerender('83d50562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductPrice.vue"
export default component.exports